export enum AnalysisPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export type SetBothSignaturesType = (
  newSignatureValue: string,
  analysisPosition?: AnalysisPosition,
  clearValues?: boolean
) => void;